module.exports = __webpack_public_path__ + "img/covid-virus.91a1f529.png";